import axios from "@/axios";
import Util from "@/util/util";

export const namespaced = true;

const defaultData = {
  orderId: 0,
  requisitionNumber: null,
  orderStatus: "DRAFT",
  creatorUserName: null,
  logisticsUserId: 0,
  financeUserId: 0,
  partnerNationId: 0,
  createDate: null,
};
const orderStatusArraySubmitted = [ 
  "SUBMITTED", "AUTHORIZED", "RECEIVED", "RETURNED", "INVOICED", "BILLED", "COMPLETED",
]

const orderStatusArrayAuthorized = [ 
 "AUTHORIZED", "RECEIVED", "RETURNED", "INVOICED", "BILLED", "COMPLETED" 
]

const orderStatusArrayReceived = [ 
   "RECEIVED", "RETURNED", "INVOICED", "BILLED", "COMPLETED"
]

const orderStatusArrayReturned = [ 
 "RETURNED", "INVOICED", "BILLED", "COMPLETED"
]

export const state = {
  orderMetadata: defaultData,
  viewOnly: false,
};

export const getters = {
  requisitionNumber: (state) => state.orderMetadata.requisitionNumber,
  orderMetadata: (state) => state.orderMetadata,
  orderStatus: (state) => state.orderMetadata.orderStatus,
  logisticsUserId: (state) => state.orderMetadata.logisticsUserId,
  financeUserId: (state) => state.orderMetadata.financeUserId,
  partnerNationId: (state) => state.orderMetadata.partnerNationId,
  isOrderViewOnly: (state) => state.viewOnly,
  isOrderCompleted: (state) => state.orderMetadata.orderStatus === "COMPLETED",
  isSubmitted:(state) => {
    if (state.orderMetadata && state.orderMetadata.orderStatus) {
      return orderStatusArraySubmitted.includes(state.orderMetadata.orderStatus);
    } else {
      // Something went wrong.
    }
  },
  isAuthorized: (state) => {
    if (state.orderMetadata && state.orderMetadata.orderStatus) {
      return orderStatusArrayAuthorized.includes(state.orderMetadata.orderStatus);
    } else {
      // Something went wrong.
    }
  },
  isReceived: (state) => {
    if (state.orderMetadata && state.orderMetadata.orderStatus) {
      return orderStatusArrayReceived.includes(state.orderMetadata.orderStatus);
    } else {
      // Something went wrong.
    }
  },
  isReturned: (state) =>  {
    if (state.orderMetadata && state.orderMetadata.orderStatus) {
      return orderStatusArrayReturned.includes(state.orderMetadata.orderStatus);
    } else {
      // Something went wrong.
    }
  },
};

export const mutations = {
  SET_REQUISITION_NUMBER: (state, response) =>
    (state.orderMetadata.requisitionNumber = response.data),
  SET_ORDER_STATUS: (state, value) => (state.orderMetadata.orderStatus = value),
  SET_LOGISTICS_USER_ID: (state, value) =>
    (state.orderMetadata.logisticsUserId = value),
  SET_PARTNERNATION_USER_ID: (state, value) =>
    (state.orderMetadata.partnerNationId = value),
  SET_FINANCE_USER_ID: (state, value) =>
    (state.orderMetadata.financeUserId = value),
  SET_ORDER_METADATA: (state, response) =>
    (state.orderMetadata = response.data),
  CLEAR_DATA: (state) => {
    state.orderMetadata = defaultData;
  },
  SET_ORDER_IS_VIEW_ONLY: (state, viewStatus) => (state.viewOnly = viewStatus),
};

export const actions = {
  clearData({ commit }) {
    commit("CLEAR_DATA");
  },
  async submitSubmission({ commit }, id) {
    commit(
      "SET_REQUISITION_NUMBER",
      await axios.post(`api/ordertransactions/submission/${id}`, {config: {showToast: false}})
    );
    commit("SET_ORDER_STATUS", "SUBMITTED");
  },
  async submitAuthorization({ commit }, id) {
    let response = await axios.post(`api/ordertransactions/authorization/${id}`);
    commit("SET_ORDER_STATUS", "AUTHORIZED");
    return response;
  },
  async submitReceiving({ commit }, id) {
    let response = await axios.post(`api/ordertransactions/receiving/${id}`);
    commit("SET_ORDER_STATUS", "RECEIVED");
    return response;
  },

  async submitReturnReplacement({commit}, id) {
    let show = state.orderMetadata.paymentMethodId === Util.MONETARY ? false : true;
    let config = { config:{ showToast: show}};
    let response = await axios.post(`api/ordertransactions/returnreplacement/${id}`, null, config);
    commit("SET_ORDER_STATUS", "RETURNED");
    return response;
  },

  async submitInvoice({ commit }, id) {
    let response = await axios.post(`api/ordertransactions/invoiced/${id}`);
    commit("SET_ORDER_STATUS", "INVOICED");
    return response;
  },
  async submitBilled({ commit }, id) {
    let response = await axios.post(`api/ordertransactions/billed/${id}`);
    commit("SET_ORDER_STATUS", "BILLED");
    return response;
  },
  async submitCompleted({ commit }, id) {
    const response = await axios.post(`api/ordertransactions/completed/${id}`, null, { config:{ showToast: false}});

    if(response && response.length === 0) {
      commit("SET_ORDER_STATUS", "COMPLETED");
      commit("SET_ORDER_IS_VIEW_ONLY", true);
      return [];
    } else {
      return response
    }
  },
  async canCompleteOrder({ commit }, id) {
    try {
      return await axios.get(`api/ordertransactions/complete/status/${id}`, {
        showToast: false,
      });
    } catch (error) {
      throw error;
    }
  },
  async getOrderMetadata({ commit }, id) {
    if (id <= 0) return;
    const res = await axios.get(`api/orders/metadata/${id}`);
   commit("SET_ORDER_METADATA", res);
  },
  async onLogisticsChange({ commit }, data) {
    try {
      let response = await axios.get(
        `/api/orderusers/Logistics/${data.orderId}`
      );
      let id = 0;

      if (response.data.orderUserId) {
        id = response.data.orderUserId;
      }

      let responsePost = await axios.post(`/api/orderusers/`, {
        orderUserId: id,
        orderId: data.orderId,
        userTypeId: Util.LOGISTICS_TYPE_ID,
        userId: data.selectedUserId,
        sendToAssigner: data.sendAssignerCopy,
        assignerNote: data.note,
      }, { config: { showToast: false   } });
      return responsePost;
    } catch (e) {
      throw e;
    }
  },
  async onFinanceChange({ commit }, data) {
    try {
      let response = await axios.get(`/api/orderusers/Finance/${data.orderId}`);
      let id = 0;

      if (response.data.orderUserId) {
        id = response.data.orderUserId;
      }

      let responsePost = await axios.post(`/api/orderusers/`, {
        orderUserId: id,
        orderId: data.orderId,
        userTypeId: Util.FINANCE_TYPE_ID,
        userId: data.selectedUserId,
        sendToAssigner: data.sendAssignerCopy,
        assignerNote: data.note,
      }, { config: { showToast: true , message: "User saved to the order and notified via email!" }});

      return responsePost;
    } catch (e) {
      throw e;
    }
  },
  async onPartnerNationChange({ commit }, data) {
    try {
      let response = await axios.get(
        `/api/orderusers/PartnerNation/${data.orderId}`
      );
      let id = 0;

      if (response.data.orderUserId) {
        id = response.data.orderUserId;
      }
      let responsePost = await axios.post(`/api/orderusers/`, {
        orderUserId: id,
        orderId: data.orderId,
        userTypeId: Util.PARTNER_NATION_TYPE_ID,
        userId: data.selectedUserId,
        sendToAssigner: data.sendAssignerCopy,
        assignerNote: data.note,
      }, { config: { showToast: true }});
      commit("SET_PARTNERNATION_USER_ID");

      return responsePost;
    } catch (e) {
      throw e;
    }
  },
  updateViewOnlyStatus({ commit }, status) {
    commit("SET_ORDER_IS_VIEW_ONLY", status);
  },
  async removeUser({commit}, data){
    try {
      const response = await axios.delete(`/api/orderusers/${data.orderId}/${data.userId}`, {config: {showToast: false}})
      return response;
    } catch (error) {
      // Something went wrong.
    }
  }

};
